import React from "react";
import "./Tech.css";
import { TechstackList } from "../../utils/TechstackList";
import Jump from "react-reveal/Jump";
const Tech = () => {
  return (
    <>
      <div className="container techstack " id="tech">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase ">
          Technologies Stack
        </h2>
        <hr />
        <p className="pb-3 text-center ">
          👉🏻including programming Languages, frameworks, databases, front-end
          and back-end tools, and APIs
        </p>
        <div className="row">
          {TechstackList.map((tech) => (
            <div key={tech._id} className="col-6 col-lg-3  ">
              <Jump>
                <div className="card m-2">
                  <div className="card-content ">
                    <div className="card-body ">
                      <div className="media d-flex justify-content-center align-items-center">
                        <div className="icon">
                          <tech.icon className="tech-icon" />
                        </div>
                        <div className="media-body name mt-2 px-2">
                          <h5>{tech.name}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Jump>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Tech;
